import { getActiveQueryClient } from '@/query/client';

/**
 * Defensive mid-session account-status handler (PTV2-1424, DESIGN §9.2).
 *
 * The account-status gate is normally resolved once at bootstrap from
 * `/me.status` in `SessionGuard`. But a user's status can change mid-session
 * (an admin deactivates them), after which the backend `AccountStatusFilter`
 * starts answering every non-`/me` path with a 403 `account_*` code. Rather
 * than let those surface as generic errors, we invalidate the cached `/me`
 * probe so `useMe()` refetches: `/me` is whitelisted for non-ACTIVE users, so
 * it returns 200 with the new `status`, and `SessionGuard` — the single source
 * of truth — re-renders the matching pending / deactivated state page.
 *
 * Idempotent and cheap: React Query dedupes concurrent invalidations, so a
 * burst of 403s from parallel in-flight requests triggers at most one refetch.
 */
export function handleAccountInactive(): void {
  void getActiveQueryClient()?.invalidateQueries({ queryKey: ['me'] });
}
